import classNames from 'classnames'
import React, { ChangeEventHandler, SFC } from 'react'
import { TranslationFunction } from 'react-i18next'
import { isPresent } from '../../app/shared'

type Props = {
  name: string
  className?: string
  initialValue?: any
  hideNoSelectedOption?: boolean
  disabled?: boolean
  onChange?: ChangeEventHandler<HTMLSelectElement>
  items?: Array<{ text: string; value: number | string }>
  id?: string
  translate?: TranslationFunction
  shouldTranslateOptions?: boolean
  noSelectedOptionText?: string
  value?: any
  shouldShowValue?: boolean
}

const PureSelect: SFC<Props> = ({
  name,
  id,
  onChange,
  disabled,
  items,
  hideNoSelectedOption,
  initialValue,
  value,
  className,
  noSelectedOptionText = 'Please select',
  translate = (_: any) => _,
  shouldTranslateOptions = false,
  shouldShowValue = false,
}) => {
  const safeValue = isPresent(value) ? value : initialValue

  return (
    <div className={classNames('bp3-select', className)}>
      <select id={id} disabled={disabled} name={name} onChange={onChange} value={safeValue}>
        {!hideNoSelectedOption && <option value="">{translate(noSelectedOptionText)}</option>}
        {items &&
          items.map((option) => (
            <option value={option.value} key={`o-${option.value}`}>
              {shouldTranslateOptions && shouldShowValue && `${option.value} - ${translate(option.text)}`}
              {shouldTranslateOptions && !shouldShowValue && translate(option.text)}
              {!shouldTranslateOptions && shouldShowValue && `${option.value} - ${option.text}`}
              {!shouldTranslateOptions && !shouldShowValue && option.text}
            </option>
          ))}
      </select>
    </div>
  )
}

export { PureSelect }



// WEBPACK FOOTER //
// ./src/modules/forms/pure-select.tsx